<div class="pagination-component d-flex justify-content-between align-items-center">
  <div class="d-flex">
      <pagination 
        [totalItems]="totalItems" 
        [(ngModel)]="currentPage" 
        [itemsPerPage]="itemsPerPage"
        (pageChanged)="emitPagedItemsChange($event.page)" 
        class="custom-pagination"
        [boundaryLinks]="true"
        [maxSize]="10"
        [rotate]="true"
        firstText="Inizio" 
        lastText="Fine" 
        previousText="Indietro" 
        nextText="Avanti">
      </pagination>
  </div>

  <div class="d-flex align-items-center gap-2">
    <label for="selectItemsPerPage" class="fw-bold">Mostra:</label>
    <select 
      id="selectItemsPerPage"
      [(ngModel)]="itemsPerPage" 
      (ngModelChange)="emitPageSizeChanged($event)"
      class="form-select form-select-sm">
        @for (option of pageSizeOptions; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
    </select>
  </div>
</div>
